import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { TimeOffService } from 'src/app/pages/timeoff/time-off.service';
import { WebixDatatablecomponent } from '../../../shared/component/time-off-grid/webix-datatable.component';
import { OrderByPipe } from 'src/app/shared/pipe/order-by.pipe';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-view-group-timeoff-modal',
  templateUrl: './view-group-timeoff-modal.component.html',
  styleUrls: ['./view-group-timeoff-modal.component.css'],
})
export class ViewGroupTimeoffModalComponent implements OnInit, AfterViewInit {
  @Input() userData: any;
  @ViewChild('timeoffGrid') grid!: WebixDatatablecomponent;
  @ViewChild('modalSize', { static: false }) modalSize: ElementRef;
  formData: { [key: string]: any } = {};
  //tempsummaryRows = null;
  monthFormat = 'MM/yyyy';
  isOpen: any[] = [];
  webixDataList: any[];
  webixGridData: any[];
  portalSettings: any;
  data: any;
  monthOn: boolean;
  newDateArray: any[];
  monthData: any[];
  orderByPipe: any;
  monthChangeTrigger: boolean;
  DateJs = <any>Date;
  datePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
    minMode: string;
  };
  format: string;
  mobileMode: boolean;
  selectedData: any[] = [];
  gridWidth = 750;
  isDataSelected = false;

  constructor(
    private activeModal: NgbActiveModal,
    private timeOffService: TimeOffService,
    portalSettingsService: PortalSettingsService,
    private utilityService: UtilityService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.format = 'MM/YYYY';
    this.datePickerOptions = {
      dateInputFormat: this.format.toUpperCase(),
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: false,
      clearPosition: 'left',
      showWeekNumbers: false,
      minMode: 'month',
    };
    this.orderByPipe = new OrderByPipe();
    this.formData.selectedMonth = new Date(
      moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
        .add(1, 'days')
        .format('YYYY-MM-DD')
    );
  }

  ngAfterViewInit(): void {
    this.grid.monthChange();
  }

  open($event, item) {
    this.isOpen = [];
    $event.preventDefault();
    $event.stopPropagation();
    this.isOpen[item] = true;
  }

  updateData(event: any) {
    this.data = event;
  }

  closeClicked() {
    this.activeModal.close();
  }
}
